import { render } from "./BaseView.vue?vue&type=template&id=035ec45c&scoped=true"
import script from "./BaseView.vue?vue&type=script&lang=js"
export * from "./BaseView.vue?vue&type=script&lang=js"

import "./BaseView.vue?vue&type=style&index=0&id=035ec45c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035ec45c"]])

export default __exports__